import React, { useEffect, useState, lazy } from 'react';
import { Check, Clock, Shield, Users, Award, Zap, FileText, FlaskConical, Download, Lock } from 'lucide-react';
import { MetaPixel } from './components/MetaPixel';
import { CTAButton } from './components/CTAButton';
import { PurchasePopup } from './components/PurchasePopup';
import { BonusCard } from './components/BonusCard';
import { TestimonialCard } from './components/TestimonialCard';
import { FAQItem } from './components/FAQItem';
import { MaterialCarousel } from './components/MaterialCarousel';
export function App() {
  // Image URLs
  const mainImage = 'https://cdn.magicpatterns.com/uploads/tADEb8GVSyx32vexiaBTUJ/PROYECTOS_Anuales_(1080_x_900_px).png';
  const bonus1Image = 'https://cdn.magicpatterns.com/uploads/6FZppY7hxbrSZPGKbc4uWo/14.png';
  const bonus2Image = 'https://cdn.magicpatterns.com/uploads/rqx1MPTvbzYGSqGwQHthbP/15.png';
  const bonus3Image = 'https://cdn.magicpatterns.com/uploads/d7gvQZDspv94fEMwmGGG6y/16.png';
  const bonus4Image = 'https://cdn.magicpatterns.com/uploads/bVkeiqNrLYDQ8aw5kqStUy/17.png';
  const bonus5Image = 'https://cdn.magicpatterns.com/uploads/rwCqUkSXZh23aibfAjnFUc/18.png';
  const bonus6Image = 'https://cdn.magicpatterns.com/uploads/67U1L6SrMjmUjDCyamRJVh/19.png';
  const superMegaPackImage = 'https://cdn.magicpatterns.com/uploads/dee4HpGBrW7nxQkp5UxRoR/Diseno_sin_titulo_(6).png';
  // Material preview images for carousel
  const materialPreviewImages = ['https://cdn.magicpatterns.com/uploads/5Pmf8a6zSvmwUxctcmLjTN/Captura_de_pantalla_2026-03-01_a_las_12.48.36_a._m..png', 'https://cdn.magicpatterns.com/uploads/1ALAWZG5dAEGYUWbrSj3k9/Captura_de_pantalla_2026-03-01_a_las_12.48.44_a._m..png', 'https://cdn.magicpatterns.com/uploads/6kpdsvKanZVZ2ETwSKzUuT/Captura_de_pantalla_2026-03-01_a_las_12.48.52_a._m..png', 'https://cdn.magicpatterns.com/uploads/h1ak6K1nFwG5ewAVupBizq/Captura_de_pantalla_2026-03-01_a_las_12.49.02_a._m..png', 'https://cdn.magicpatterns.com/uploads/xerdqV4cruhzia1CKbTCEC/Captura_de_pantalla_2026-03-01_a_las_12.49.09_a._m..png', 'https://cdn.magicpatterns.com/uploads/mn3287FPEpQiM1iGiQE5Tr/Captura_de_pantalla_2026-02-04_a_la(s)_10.19.34_p._m..png', 'https://cdn.magicpatterns.com/uploads/5u1u6V1EQJVyGFBzNXem9Y/Captura_de_pantalla_2026-02-04_a_la(s)_10.19.45_p._m..png', 'https://cdn.magicpatterns.com/uploads/fNNqpj2pzssmM1qntCidkM/Captura_de_pantalla_2026-02-04_a_la(s)_10.20.08_p._m..png', 'https://cdn.magicpatterns.com/uploads/sBEPb5L8h4fGV3e8trUP55/Captura_de_pantalla_2026-02-04_a_la(s)_10.20.16_p._m..png', 'https://cdn.magicpatterns.com/uploads/fKkJL9JSGehm4GzrFwPn7X/Captura_de_pantalla_2026-02-04_a_la(s)_10.20.39_p._m..png', 'https://cdn.magicpatterns.com/uploads/birue1ErAeDFCGwVNBkwkp/Captura_de_pantalla_2026-02-04_a_la(s)_10.27.32_p._m..png', 'https://cdn.magicpatterns.com/uploads/7nY7ACNWKyyvfRpKHzeJfo/Captura_de_pantalla_2026-02-04_a_la(s)_10.27.38_p._m..png', 'https://cdn.magicpatterns.com/uploads/iyz8vf2i9gSjcmGVg1DsYs/Captura_de_pantalla_2026-02-04_a_la(s)_10.27.54_p._m..png', 'https://cdn.magicpatterns.com/uploads/s12XFcgoD97FGdB6nPs6Na/Captura_de_pantalla_2026-02-04_a_la(s)_10.28.11_p._m..png', 'https://cdn.magicpatterns.com/uploads/b1TwJoD3YUF71ZQN5PZSy4/Captura_de_pantalla_2026-02-04_a_la(s)_10.28.19_p._m..png'];
  // Countdown Timer Logic
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 14,
    seconds: 56
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            ...prev,
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        } else {
          // Reset timer for demo purposes
          return {
            hours: 0,
            minutes: 14,
            seconds: 56
          };
        }
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (num: number) => num.toString().padStart(2, '0');
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <PurchasePopup data-id="element-2" />

      {/* 1. Top Bar */}
      <div className="bg-emerald-800 text-white py-2 text-center text-sm font-bold sticky top-0 z-50 shadow-md" data-id="element-3">
        <div className="flex items-center justify-center gap-2" data-id="element-4">
          <Clock className="h-4 w-4" data-id="element-5" />
          <span data-id="element-6">
            Oferta termina en: {formatTime(timeLeft.hours)}:
            {formatTime(timeLeft.minutes)}:{formatTime(timeLeft.seconds)}
          </span>
        </div>
      </div>

      {/* 2. Hero Section */}
      <header className="bg-white pt-6 pb-16 px-4" data-id="element-7">
        <div className="max-w-4xl mx-auto text-center" data-id="element-8">
          <div className="inline-flex items-center gap-2 text-emerald-600 font-bold uppercase tracking-wider text-sm mb-4 border border-emerald-100 bg-emerald-50 px-4 py-1 rounded-full" data-id="element-9">
            <FlaskConical className="h-4 w-4" data-id="element-10" />
            PARA DOCENTES DE QUÍMICA
          </div>

          <h1 className="text-xl md:text-3xl font-extrabold text-gray-900 mb-4 leading-tight" data-id="element-11">
            Organizá todo tu año de Química y{' '}
            <span className="text-emerald-600" data-id="element-12">
              ahorrá hasta 12 meses de planificación
            </span>{' '}
            con el Mega Pack Química Lista
          </h1>

          <div className="max-w-[280px] mx-auto mb-4" data-id="element-13">
            <img src={mainImage} alt="Mega Pack Química Lista" className="w-full h-auto transform hover:scale-105 transition-transform duration-500" fetchPriority="high" decoding="async" data-id="element-14" />
          </div>

          <div className="flex items-center justify-center gap-2 text-emerald-600 font-bold text-lg mb-2" data-id="element-15">
            <FlaskConical className="h-5 w-5" data-id="element-16" />
            <span data-id="element-17">MEGAPACK QUÍMICA LISTA™</span>
          </div>

          <p className="text-base md:text-lg text-gray-600 mb-6 max-w-2xl mx-auto" data-id="element-18">
            Sistema completo de clases, actividades y proyectos de química
            listos para usar.{' '}
            <span className="font-bold text-gray-900" data-id="element-19">
              Todo tu año resuelto (todos los niveles)
            </span>
          </p>

          <div className="flex flex-col items-center gap-4" data-id="element-20">
            <CTAButton size="xl" scrollToId="pricing" data-id="element-21">
              👉 SÍ, QUIERO ACCESO INMEDIATO
            </CTAButton>

            <div className="flex flex-wrap justify-center gap-4 text-xs text-gray-500 mt-2" data-id="element-22">
              <span className="flex items-center gap-1" data-id="element-23">
                <Lock className="h-3 w-3" data-id="element-24" /> Pago seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-25">
                <Download className="h-3 w-3" data-id="element-26" /> Descarga inmediata
              </span>
              <span className="flex items-center gap-1" data-id="element-27">
                <Shield className="h-3 w-3" data-id="element-28" /> Garantía 7 días
              </span>
              <span className="flex items-center gap-1" data-id="element-29">
                <Check className="h-3 w-3" data-id="element-30" /> Acceso de por vida
              </span>
            </div>
          </div>
        </div>
      </header>

      {/* 3. Problem Section */}
      <section className="py-16 bg-gray-50 px-4" data-id="element-31">
        <div className="max-w-3xl mx-auto" data-id="element-32">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-10" data-id="element-33">
            Si enseñás Química, esto te va a{' '}
            <span className="text-emerald-600" data-id="element-34">sonar familiar...</span>
          </h2>

          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 mb-8" data-id="element-35">
            <p className="text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-36">
              Llegás del trabajo <span className="font-bold" data-id="element-37">agotado</span> y
              tenés que planificar. Horas buscando experimentos, diseñando
              experiencias, armando evaluaciones...
            </p>
            <p className="text-lg text-gray-700 font-medium" data-id="element-38">
              No es falta de capacidad. Es que te falta un sistema integral que
              te sostenga todo el año.
            </p>
          </div>
        </div>
      </section>

      {/* 4. Solution Section */}
      <section className="py-16 bg-white px-4 text-center" data-id="element-39">
        <div className="max-w-4xl mx-auto" data-id="element-40">
          <span className="text-emerald-600 font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-41">
            La Solución
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-42">
            MEGAPACK QUÍMICA LISTA™
          </h2>
          <p className="text-xl text-gray-600 mb-12 max-w-2xl mx-auto" data-id="element-43">
            Sistema completo de proyectos, experiencias y evaluaciones ya
            probadas en el aula.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-44">
            {[{
            icon: Check,
            text: 'Listo'
          }, {
            icon: FlaskConical,
            text: 'Probado'
          }, {
            icon: FileText,
            text: 'Organizado'
          }, {
            icon: Zap,
            text: 'Usable'
          }].map((item, i) => <div key={i} className="flex flex-col items-center p-4 bg-emerald-50 rounded-xl" data-id="element-45">
                <div className="bg-white p-3 rounded-full shadow-sm mb-3" data-id="element-46">
                  <item.icon className="h-6 w-6 text-emerald-600" data-id="element-47" />
                </div>
                <span className="font-bold text-gray-800" data-id="element-48">{item.text}</span>
              </div>)}
          </div>
        </div>
      </section>

      {/* 5. What Includes Section */}
      <section className="py-16 bg-gray-50 px-4" data-id="element-49">
        <div className="max-w-5xl mx-auto" data-id="element-50">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-51">
            ¿Qué Incluye?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-52">
            {['6 tomos completos (1.º a 6.º año)', '60+ fichas editables', 'Proyectos anuales listos', 'Planillas y rúbricas', 'Videos demostrativos', 'Material para ferias y exposiciones'].map((item, i) => <div key={i} className="flex items-center p-4 bg-white rounded-xl shadow-sm border border-gray-100" data-id="element-53">
                <div className="bg-emerald-100 p-2 rounded-full mr-4 flex-shrink-0" data-id="element-54">
                  <Check className="h-5 w-5 text-emerald-600" data-id="element-55" />
                </div>
                <span className="font-medium text-gray-800" data-id="element-56">{item}</span>
              </div>)}
          </div>
        </div>
      </section>

      {/* 6. Inside Look Section */}
      <section className="py-16 bg-white px-4 text-center" data-id="element-57">
        <div className="max-w-4xl mx-auto" data-id="element-58">
          <h2 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-59">
            MIRÁ POR DENTRO
          </h2>
          <p className="text-xl text-emerald-600 font-medium mb-4" data-id="element-60">
            Páginas reales del material
          </p>
          <p className="text-gray-600 mb-8" data-id="element-61">
            Proyectos paso a paso, clases listas y actividades prácticas
          </p>

          <MaterialCarousel images={materialPreviewImages} data-id="element-62" />
        </div>
      </section>

      {/* 7. Results Section */}
      <section className="py-16 bg-gray-50 px-4" data-id="element-63">
        <div className="max-w-5xl mx-auto" data-id="element-64">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-65">
            Resultados que transforman
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-66">
            {/* Students */}
            <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-emerald-500" data-id="element-67">
              <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-68">
                <Users className="h-6 w-6 text-emerald-600 mr-2" data-id="element-69" />
                Para tus Estudiantes
              </h3>
              <ul className="space-y-4" data-id="element-70">
                {['Comprenden desde la práctica', 'Conectan teoría y realidad', 'Desarrollan razonamiento científico', 'Participan más en clase'].map((item, i) => <li key={i} className="flex items-start" data-id="element-71">
                    <Check className="h-5 w-5 text-emerald-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-72" />
                    <span className="text-gray-700" data-id="element-73">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* Teachers */}
            <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-blue-500" data-id="element-74">
              <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-75">
                <Award className="h-6 w-6 text-blue-600 mr-2" data-id="element-76" />
                Para Vos como Docente
              </h3>
              <ul className="space-y-4" data-id="element-77">
                {['Ahorrás horas de planificación', 'Enseñás con claridad', 'Todo organizado', 'Llegás sin estrés al cierre'].map((item, i) => <li key={i} className="flex items-start" data-id="element-78">
                    <Check className="h-5 w-5 text-blue-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-79" />
                    <span className="text-gray-700" data-id="element-80">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="mt-12 text-center" data-id="element-81">
            <CTAButton size="xl" scrollToId="pricing" data-id="element-82">
              👉 QUIERO LOGRAR ESTO
            </CTAButton>
          </div>
        </div>
      </section>

      {/* 8. Bonuses Section */}
      <section className="py-16 bg-white px-4" data-id="element-83">
        <div className="max-w-6xl mx-auto" data-id="element-84">
          <div className="text-center mb-12" data-id="element-85">
            <h2 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-86">
              🎁 BONOS GRATIS HOY
            </h2>
            <p className="text-xl text-emerald-600 font-medium" data-id="element-87">
              Te llevás 6 bonos exclusivos
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-88">
            <BonusCard bonusNumber={1} title="Mezclas, reacciones y energía" description="Ejercicios guiados para activar la práctica desde la semana 1." imageSrc={bonus1Image} data-id="element-89" />
            <BonusCard bonusNumber={2} title="Conceptos fundamentales" description="Base clara para nivelar grupos heterogéneos." imageSrc={bonus2Image} data-id="element-90" />
            <BonusCard bonusNumber={3} title="Química orgánica y vida cotidiana" description='Ejemplos reales para enganchar incluso a quienes "odian química".' imageSrc={bonus3Image} data-id="element-91" />
            <BonusCard bonusNumber={4} title="Cuaderno interactivo de actividades" description="Registros y experiencias listas para aplicar en clase." imageSrc={bonus4Image} data-id="element-92" />
            <BonusCard bonusNumber={5} title="Química general y orgánica" description="Puente completo para secuenciar contenidos durante todo el año." imageSrc={bonus5Image} data-id="element-93" />
            <BonusCard bonusNumber={6} title="Planilla de seguimiento" description="Rúbrica + criterios listos para evaluar sin improvisar." imageSrc={bonus6Image} data-id="element-94" />
          </div>
        </div>
      </section>

      {/* 9. Pricing Section */}
      <section className="py-8 md:py-16 bg-emerald-900 px-4 relative overflow-hidden" data-id="element-95">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10" data-id="element-96">
          <div className="absolute top-0 left-0 w-64 h-64 bg-white rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-97"></div>
          <div className="absolute bottom-0 right-0 w-64 h-64 bg-emerald-400 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" data-id="element-98"></div>
        </div>

        <div className="max-w-md mx-auto relative z-10" data-id="element-99">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden" data-id="element-100">
            <div className="bg-red-600 text-white text-center py-2 font-bold text-sm uppercase tracking-wide animate-pulse" data-id="element-101">
              🔥 OFERTA ESPECIAL POR TIEMPO LIMITADO
            </div>

            <div className="p-5 md:p-8 text-center" data-id="element-102">
              <h3 className="text-xl md:text-2xl font-black text-gray-900 mb-1" data-id="element-103">
                MEGAPACK QUÍMICA LISTA
              </h3>
              <p className="text-emerald-600 font-bold mb-4" data-id="element-104">
                6 Tomos Base + 6 Bonos PRO
              </p>

              <div className="space-y-2 mb-5 text-left" data-id="element-105">
                {['Pago único', 'Acceso de por vida', 'Descarga inmediata', 'Garantía 7 días', '6 Bonos incluidos'].map((item, i) => <div key={i} className="flex items-center" data-id="element-106">
                    <Check className="h-4 w-4 text-emerald-500 mr-3 flex-shrink-0" data-id="element-107" />
                    <span className="text-gray-700 text-sm" data-id="element-108">{item}</span>
                  </div>)}
              </div>

              <div id="pricing" className="mb-1" data-id="element-109">
                <span className="text-gray-400 line-through text-base" data-id="element-110">
                  Precio regular $49.99 USD
                </span>
              </div>
              <div className="flex items-center justify-center gap-2 mb-1" data-id="element-111">
                <span className="text-5xl md:text-6xl font-black text-gray-900" data-id="element-112">
                  $9.97
                </span>
                <span className="text-lg font-bold text-gray-500 self-end mb-1" data-id="element-113">
                  USD
                </span>
              </div>
              <p className="text-xs text-gray-500 mb-5" data-id="element-114">
                Pago único · Pagarás en tu moneda local
              </p>

              <CTAButton fullWidth size="xl" href="https://docentes.edulabs.online/cart/47462616269049:1" data-id="element-115">
                👉 SÍ, QUIERO EL MEGAPACK
              </CTAButton>
            </div>
          </div>
        </div>
      </section>

      {/* 10. Super MegaPack Section */}
      <section className="py-8 md:py-16 bg-gray-50 px-4" data-id="element-116">
        <div className="max-w-4xl mx-auto" data-id="element-117">
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden border-2 border-orange-100 relative" data-id="element-118">
            <div className="absolute top-0 right-0 bg-orange-500 text-white px-4 py-1.5 rounded-bl-xl font-bold text-sm shadow-sm z-10" data-id="element-119">
              ⭐ MÁS POPULAR
            </div>

            <div className="flex flex-col" data-id="element-120">
              {/* Imagen centrada */}
              <div className="bg-gray-50 p-5 flex items-center justify-center" data-id="element-121">
                <img src={superMegaPackImage} alt="Super MegaPack Física + Química" className="w-full h-auto max-w-xs md:max-w-sm" loading="lazy" decoding="async" data-id="element-122" />
              </div>

              {/* Contenido centrado */}
              <div className="p-5 md:p-10 text-center" data-id="element-123">
                <h3 className="text-2xl md:text-3xl font-black text-gray-900 mb-1" data-id="element-124">
                  SUPER MEGAPACK COMPLETO
                </h3>
                <p className="text-xl font-bold text-emerald-600 mb-2" data-id="element-125">
                  FÍSICA + QUÍMICA
                </p>
                <p className="text-gray-600 mb-4 text-sm" data-id="element-126">
                  12 Cuadernillos completos + 10 Bonos
                </p>

                <div className="grid grid-cols-2 gap-3 mb-5 max-w-md mx-auto" data-id="element-127">
                  {['Física completa', 'Química completa', '10 Bonos incluidos', 'Garantía 7 días'].map((item, i) => <div key={i} className="flex items-center justify-center" data-id="element-128">
                      <Check className="h-4 w-4 text-emerald-500 mr-2 flex-shrink-0" data-id="element-129" />
                      <span className="text-sm text-gray-700" data-id="element-130">{item}</span>
                    </div>)}
                </div>

                <div className="flex flex-col items-center gap-1 mb-5" data-id="element-131">
                  <span className="text-gray-400 line-through text-sm" data-id="element-132">
                    Valor separado $27.98 USD
                  </span>
                  <div className="flex items-baseline gap-2" data-id="element-133">
                    <span className="text-4xl md:text-5xl font-black text-gray-900" data-id="element-134">
                      $14.99
                    </span>
                    <span className="text-lg font-bold text-gray-500" data-id="element-135">USD</span>
                  </div>
                  <span className="text-emerald-600 font-bold text-sm" data-id="element-136">
                    ¡Ahorrás $12.99 USD más!
                  </span>
                </div>

                <div className="max-w-md mx-auto" data-id="element-137">
                  <CTAButton fullWidth href="https://docentes.edulabs.online/cart/47462806880505:1" data-id="element-138">
                    👉 SÍ, QUIERO EL SUPER MEGAPACK
                  </CTAButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 11. Guarantee Section */}
      <section className="py-16 bg-white px-4 text-center" data-id="element-139">
        <div className="max-w-2xl mx-auto" data-id="element-140">
          <div className="inline-block p-4 bg-emerald-100 rounded-full mb-6" data-id="element-141">
            <Shield className="h-12 w-12 text-emerald-600" data-id="element-142" />
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-143">
            Garantía de Satisfacción Total
          </h2>
          <p className="text-xl text-gray-600" data-id="element-144">
            Probalo 7 días. Si no cumple, te devolvemos el 100%. Sin preguntas.
          </p>
        </div>
      </section>

      {/* 12. Testimonials Section */}
      <section className="py-16 bg-gray-50 px-4" data-id="element-145">
        <div className="max-w-6xl mx-auto" data-id="element-146">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-147">
            Testimonios de Docentes
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-148">
            <TestimonialCard name="María G." role="Docente de Química" location="Bogotá, Colombia" content="Ahora organizo todo el año sin estrés. Es increíble el tiempo que ahorro." initials="MG" data-id="element-149" />
            <TestimonialCard name="Gustavo L." role="Profesor de Ciencias" location="Ciudad de México" content="Los estudiantes se involucraron más. Las clases cambiaron por completo." initials="GL" data-id="element-150" />
            <TestimonialCard name="Roberto P." role="Docente de Secundaria" location="Buenos Aires" content="Mis clases son más dinámicas y los alumnos participan activamente." initials="RP" data-id="element-151" />
          </div>
        </div>
      </section>

      {/* 13. FAQ Section */}
      <section className="py-16 bg-white px-4" data-id="element-152">
        <div className="max-w-3xl mx-auto" data-id="element-153">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-154">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-2" data-id="element-155">
            <FAQItem question="¿En qué formato recibo el material?" answer="100% digital: PDF descargables listos para usar." data-id="element-156" />
            <FAQItem question="¿Puedo imprimir los cuadernillos?" answer="Sí, sin restricciones." data-id="element-157" />
            <FAQItem question="¿Para qué niveles sirve?" answer="De 1.º a 6.º año de Secundaria/Bachillerato." data-id="element-158" />
            <FAQItem question="¿Necesito laboratorio?" answer="No. Se adaptan a materiales accesibles." data-id="element-159" />
            <FAQItem question="¿Cuánto tarda en llegar?" answer="Acceso inmediato tras la compra." data-id="element-160" />
          </div>
        </div>
      </section>

      {/* 14. Final CTA */}
      <section className="py-20 bg-emerald-600 text-white px-4 text-center" data-id="element-161">
        <div className="max-w-4xl mx-auto" data-id="element-162">
          <h2 className="text-3xl md:text-5xl font-extrabold mb-6" data-id="element-163">
            ¿Listo para transformar tu año escolar?
          </h2>
          <p className="text-xl md:text-2xl text-emerald-100 mb-10" data-id="element-164">
            Unite a cientos de docentes que ya organizaron su año sin estrés
          </p>
          <div className="flex justify-center" data-id="element-165">
            <CTAButton size="xl" variant="white" scrollToId="pricing" data-id="element-166">
              👉 QUIERO EMPEZAR AHORA
            </CTAButton>
          </div>
        </div>
      </section>

      {/* 15. Footer */}
      <footer className="bg-gray-900 text-gray-400 py-12 px-4 text-center border-t border-gray-800" data-id="element-167">
        <div className="max-w-6xl mx-auto" data-id="element-168">
          <p className="mb-4 font-bold text-white tracking-wider" data-id="element-169">
            MEGAPACK QUÍMICA LISTA™
          </p>
          <p className="text-sm mb-6" data-id="element-170">
            © 2026 Mega Pack Química Lista™. Todos los derechos reservados.
          </p>
          <div className="flex justify-center space-x-6 text-sm" data-id="element-171">
            <span className="hover:text-white cursor-pointer transition-colors" data-id="element-172">
              Términos
            </span>
            <span className="hover:text-white cursor-pointer transition-colors" data-id="element-173">
              Privacidad
            </span>
            <span className="hover:text-white cursor-pointer transition-colors" data-id="element-174">
              Soporte
            </span>
          </div>
        </div>
      </footer>
    </div>;
}